import { render } from "./App.vue?vue&type=template&id=3626dc87"
const script = {}

import exportComponent from "/home/runner/work/azia2012/azia2012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__